var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"mcr-loading-indicator"},[_c('div',{staticClass:"spinner",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"cube1",style:(_vm.cubeColor)}),_c('div',{staticClass:"cube2",style:(_vm.cubeColor)})]),(_vm.message)?_c('div',{staticClass:"loading-message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }